import { render, staticRenderFns } from "./FacebookLogTable.vue?vue&type=template&id=f9fdba7c&scoped=true"
import script from "./FacebookLogTable.vue?vue&type=script&lang=js"
export * from "./FacebookLogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fdba7c",
  null
  
)

export default component.exports